import type { AIError } from '@cadencia/contracts';

/**
 * Por qué la IA no ha dado un resultado, dicho sin jerga de la API y distinto
 * según la causa (encargo del 23/09/2026, §6: seguridad, datos y fallo técnico
 * no se mezclan en un estado ambiguo).
 *
 * Nació en `evidenceService` y se sacó el 24/09/2026 porque `proposeBlock`
 * devolvía `null` para cualquier fallo: el bloque salía de la plantilla y
 * nadie sabía si era por el presupuesto, por la red o porque la respuesta no
 * valía. Cada causa se arregla de una forma, así que se dice cuál.
 *
 * `accion` es el verbo de lo que se intentaba («revisar», «proponer el
 * bloque»), para el caso en que la causa es técnica.
 */
export function motivoDeFalloIA(error: AIError, accion: string): string {
  switch (error.kind) {
    case 'rate_limited':
      return 'demasiadas peticiones seguidas: espera un momento';
    case 'budget_exceeded':
      return 'se ha agotado el presupuesto de IA de este mes';
    case 'disabled':
      return 'la IA no se ha usado' + (error.detail !== undefined ? `: ${error.detail}` : '');
    case 'unavailable':
      return error.detail !== undefined
        ? `no se pudo ${accion}: ${error.detail}`
        : `no se pudo ${accion} (sin respuesta de la IA)`;
    case 'invalid_output':
      // Sin su detalle es un callejón sin salida: dice que la respuesta no
      // valía y no por qué, y esa llamada ya se ha pagado.
      return `la respuesta de la IA no pasó la validación: ${error.details.slice(0, 200)}`;
    case 'rejected_by_rules':
      return `la respuesta de la IA no pasó las reglas: ${error.violations.join(', ').slice(0, 200)}`;
  }
}
